// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FileFeatureSelector
 */
export interface FileFeatureSelector {
  /**
   *
   */
  layerName: string;
  /**
   *
   */
  featureIds: Array<number>;
}

/**
 * Check if a given object implements the FileFeatureSelector interface.
 */
export function instanceOfFileFeatureSelector(value: object): value is FileFeatureSelector {
  if (
    (!("layerName" in (value as Record<string, any>)) &&
      !("layer_name" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["layerName"] === undefined &&
      (value as Record<string, any>)["layer_name"] === undefined)
  )
    return false;
  if (
    (!("featureIds" in (value as Record<string, any>)) &&
      !("feature_ids" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["featureIds"] === undefined &&
      (value as Record<string, any>)["feature_ids"] === undefined)
  )
    return false;
  return true;
}

export function FileFeatureSelectorFromJSON(json: any): FileFeatureSelector {
  return FileFeatureSelectorFromJSONTyped(json, false);
}

export function FileFeatureSelectorFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FileFeatureSelector {
  if (json == null) {
    return json;
  }
  return {
    layerName: json["layer_name"],
    featureIds: json["feature_ids"],
  };
}

export function FileFeatureSelectorToJSON(json: any): FileFeatureSelector {
  return FileFeatureSelectorToJSONTyped(json, false);
}

export function FileFeatureSelectorToJSONTyped(
  value?: FileFeatureSelector | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    layer_name: value["layerName"],
    feature_ids: value["featureIds"],
  };
}
